module.exports = __webpack_public_path__ + "img/mision.e6099242.png";